import React from 'react'
import ScopeTemplate from '../../components/ScopeTemplate/ScopeTemplate'

function Defence() {
    const overview =
        'Accelor Microsystems undertakes design, development, manufacturing, and qualification of electronic systems for defence applications under an integrated in-house infrastructure. Activities are executed in adherence to applicable MIL, JSS, and IPC standards within a structured Quality Management System. Our facility supports complete lifecycle realization from concept and prototyping to mass production and qualification.'

    const points = [
        'Embedded hardware & software development for mission-critical systems',
        'Precision guidance, control & power electronics modules',
        'MIL/JSS compliant PCB fabrication & electronic assembly',
        'Environmental qualification (thermal, vibration, shock, humidity) - In-house NABL Accredited Lab',
        'DGQA / R&QA aligned documentation, testing & quality assurance',
    ]

    const tags = [
        'Design',
        'Development',
        'Manufacturing',
        'Qualification',
    ]

    return (
        <ScopeTemplate
            title='DEFENCE'
            subtitle='Electronic Systems for Defence Applications'
            overview={overview}
            points={points}
            tags={tags}
        />
    )
}

export default Defence